import { useTranslation } from "react-i18next";
import { useProjectList } from "@/pages/consumption/view/billing-details/view/volume-detail/hooks/useProjectList";
import { useGlobalStore } from "@/store/GlobalStore";

export function useProjectOptions(isOld = false) {
  const { t } = useTranslation("consumption");
  const projectList = useProjectList();
  const { isSubAccount } = useGlobalStore();

  return [
    {
      value: 0,
      label: t("user_consume_pick_project_empty"),
    },
    ...(projectList?.map((p) => {
      let projectName = p.projectName;
      if (p.isMain === 0 && isSubAccount) {
        projectName = `${projectName}${t("user_consume_project_master_suf")}`;
      }
      if (p.isMain !== 0 && !isSubAccount) {
        projectName = `${projectName}${t("user_consume_project_sub_suf")}`;
      }
      return {
        label: projectName,
        value: p.projectId,
      };
    }) ?? []),
  ];
}
